import {createStore} from 'vuex'
import mqtt from './mqtt'


const store = createStore({
  modules: {
    mqtt,
  },
})

export default store


